var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlayVideo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.003,
    height: 11.001,
    viewBox: "0 0 11.003 11.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.423,420.019a1.49,1.49,0,0,0-.754-.864l-8-4a1.527,1.527,0,0,0-1.733.281,1.486,1.486,0,0,0-.438,1.061v8a1.5,1.5,0,0,0,2.17,1.351l8-4a1.513,1.513,0,0,0,.674-.675l0-.005A1.5,1.5,0,0,0,303.423,420.019Z",
    transform: "translate(-292.499 -415.003)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlayVideo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play-video.347df734.svg";
export { ForwardRef as ReactComponent };